import { getLogger } from './logger';

const { logInfo, logWarn } = getLogger({ location: 'check-is-in-iframe' });

// Check whether we are in top most window (aka not in an iframe)
// Some browsers (Internet explorer) may throw an error when
// trying to access window.top if running in an iframe
const checkIsInIframe = () => {
  if (typeof window === 'undefined') {
    logInfo('SSR detected');
    return false;
  }

  try {
    const isInIframe = window.self !== window.top;

    return isInIframe;
  } catch (e) {
    logWarn('iframe detection error (assuming iframe)', { error: String(e) });
    return true;
  }
};

export default checkIsInIframe;
